import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Building2, TrendingUp, Briefcase, Users, KanbanSquare,
  Sparkles, FileCheck, Video, Award, Bot, Users2, UserCheck, Contact2,
  CreditCard, GraduationCap, CalendarCheck, CheckSquare, BarChart3, Layers, Settings, LogOut, Globe2, ShieldCheck,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { BrandLockup } from "./ConnectMyHubLogo";

const SECTIONS = [
  { title: "OVERVIEW", items: [
    { label: "Executive Dashboard", icon: LayoutDashboard, path: "/dashboard" },
    { label: "Companies & CRM", icon: Building2, path: "/companies" },
    { label: "Opportunities", icon: TrendingUp, path: "/opportunities", soon: true },
  ]},
  { title: "RECRUITING & TALENT", items: [
    { label: "Job Orders", icon: Briefcase, path: "/job-orders" },
    { label: "Talent Network", icon: Users, path: "/candidates" },
    { label: "Qualification Board", icon: ShieldCheck, path: "/qualification" },
    { label: "Recruiting Pipeline", icon: KanbanSquare, path: "/pipeline" },
    { label: "AI Matching Engine", icon: Sparkles, path: "/matching" },
    { label: "Media Review", icon: Video, path: "/media-review" },
    { label: "Client Shortlists", icon: FileCheck, path: "/shortlists" },
    { label: "Interviews", icon: Video, path: "/interviews" },
    { label: "Placements & Guarantees", icon: Award, path: "/placements" },
    { label: "Talent Sourcing", icon: Globe2, path: "/sourcing-requests" },
  ]},
  { title: "WORKFORCE ORCHESTRATION", items: [
    { label: "Managed & AI Workforce", icon: Bot, path: "/workforce", soon: true },
    { label: "ConnectMyHub Teams™", icon: Users2, path: "/teams", soon: true },
    { label: "Recruiters", icon: UserCheck, path: "/recruiters" },
    { label: "Clients Directory", icon: Contact2, path: "/clients", soon: true },
  ]},
  { title: "OPERATIONS & ANALYTICS", items: [
    { label: "Memberships", icon: CreditCard, path: "/memberships", soon: true },
    { label: "Training & Academy", icon: GraduationCap, path: "/academy", soon: true },
    { label: "Check-Ins", icon: CalendarCheck, path: "/check-ins", soon: true },
    { label: "Tasks & Action Center", icon: CheckSquare, path: "/tasks", soon: true },
    { label: "Reports & ROI Analytics", icon: BarChart3, path: "/reports", soon: true },
    { label: "Integrations", icon: Layers, path: "/integrations", soon: true },
    { label: "Country Configuration", icon: Globe2, path: "/countries-admin" },
    { label: "Employer Approvals", icon: ShieldCheck, path: "/admin/employers" },
    { label: "Commercial Center", icon: CreditCard, path: "/admin/commercial" },
    { label: "State Compliance", icon: ShieldCheck, path: "/admin/compliance" },
    { label: "Account & Security", icon: ShieldCheck, path: "/account" },
  ]},
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  return (
    <aside data-testid="app-sidebar" className="w-64 shrink-0 bg-slate-900 text-slate-100 flex flex-col border-r border-slate-800 min-h-screen">
      <div className="px-5 pt-6 pb-5 border-b border-slate-800">
        <BrandLockup />
      </div>
      <nav className="flex-1 overflow-y-auto py-4 px-2">
        {SECTIONS.map((sec) => (
          <div key={sec.title} className="mb-5">
            <div className="text-[10px] font-semibold text-slate-500 uppercase tracking-widest px-3 mb-2">{sec.title}</div>
            {sec.items.map((it) => {
              const Icon = it.icon;
              return (
                <NavLink
                  key={it.path}
                  to={it.path}
                  data-testid={`nav-${it.path.replace('/','')}`}
                  className={({isActive}) =>
                    `flex items-center gap-3 px-3 py-2 rounded-md text-sm mb-0.5 transition-colors ${
                      isActive ? "bg-slate-800 text-white border-l-2 border-sky-500 pl-[10px]" : "text-slate-300 hover:bg-slate-800/70 hover:text-white"
                    }`
                  }
                >
                  <Icon size={16} className="shrink-0" />
                  <span className="flex-1 truncate">{it.label}</span>
                  {it.soon && <span className="text-[9px] uppercase tracking-wider text-slate-500 border border-slate-700 rounded px-1.5 py-0.5">Soon</span>}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>
      <div className="border-t border-slate-800 p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-9 h-9 rounded-full bg-slate-700 flex items-center justify-center font-semibold text-sm">{(user?.name || "U").slice(0,1)}</div>
          <div className="min-w-0 flex-1">
            <div className="text-sm font-medium truncate">{user?.name}</div>
            <div className="text-[11px] text-slate-400 truncate">{user?.role?.replace('_',' ')}</div>
          </div>
        </div>
        <button
          data-testid="logout-btn"
          onClick={logout}
          className="w-full flex items-center gap-2 justify-center text-xs font-medium text-slate-300 hover:text-white border border-slate-700 hover:border-slate-600 rounded-md py-2 transition-colors"
        >
          <LogOut size={13} /> Sign out
        </button>
      </div>
    </aside>
  );
}
